 <div class="platform-options" *ngIf="mustBePresented()">
      <div class="header">Choose a platform
      </div>
      <div class="message" *ngIf="platformList.length <= 0">
        <span>No platform information available</span>
      </div>
      
      <div class="platform">
        <div class="platform-item" *ngFor="let platform of platformList">
          <div class="platform-item-wrapper"
                [ngClass]="{'selected-platform' : platform.selected}"
                (click)="_onClick(platform)">
            <div class="platform-icon" [ngClass]="{'selected-icon' : platform.selected}">
                <mat-icon> check_circle_outline</mat-icon>
            </div>
            
            <div class="platform-item-content">
              <div class="label">{{platform.label}}</div>
              <div class="description platform">
                {{platform.description}}
                <!--<a [href]="platform.helpLink" target="_blank">Learn more</a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      
</div>
